import { Alert, Box, Button, IconButton, Snackbar } from "@mui/material";
import ProjectHeader from "../../components/new/ProjectHeader";
import ProjectLabelPart from "../../components/new/ProjectLabelPart";
import AIOptionPart from "../../components/new/AIOptionPart";
import ServerSelectModal from "../../components/new/ServerSelectModal";
import WelcomeGuideModal, { isGuideSeen } from "../../components/new/WelcomeGuideModal";
import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { getLatestTrainHistory } from "../../services/projectService";
import { getAIServerList } from "../../services/serverRuleService";
import { ServerModalStyle } from "../../components/Header";
import {
  isTrainingState,
  overkillCountState,
  overkillPercentState,
  parentModelState,
  projectCountInfoState,
  projectInfoState,
  selectedImageState,
} from "../../recoil";
import { useRecoilState, useRecoilValue, useResetRecoilState } from "recoil";
import ImagePart from "../../components/new/ImagePart";
import { getMyModuleServer, importAIModules, exportAIModules } from "common-lib";
import { removeImportedModules } from "../../services/aiServer";
import { AI_SERVER_DISCONNECTED_EVENT } from "../../services/client";
import {
  imageDataState,
  imageViewModeState,
  inspModelUuidState,
  myAIModuleState,
  trainingStateAtom,
  trainUuidState,
} from "../../recoil/upgrade";
import { toast } from "react-toastify";
import { CloseIcon } from "common-lib";
import { useLayoutStore } from "../../stores/ui.store";
import { useTrainingStore } from "../../stores/training.store";
import { LabelingProvider } from "../../context/LabelingContext";
import { useTutorial } from "../../context/TutorialContext";
import { TUTORIALS } from "../../tutorial";
import { pickLabelScores, useInspImage } from "../../hooks/useInspImage";
import { InspImageProvider } from "../../context/InspImageProvider";
import { useHeatmapModel } from "../../hooks/useHeatmapModel";
import { getInspModel } from "../../services/inspModelService";

export default function ProjectMainPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  // 검사모델 문제로 import 실패 시 모달에 원인 표시
  const [modelError, setModelError] = useState<string | null>(null);
  const { label } = useParams();
  const [projectData, setProjectData] = useRecoilState(projectInfoState);
  const [userConfig, setUserConfig] = useState<any>(null);
  const [serverList, setServerList] = useState<any[]>([]);
  const { run, nextSubStep, tutorialKey, stepIndex, pendingStartRef, startTour, tutorialKeyRef } = useTutorial();
  const [isOpenServerModal, setIsOpenServerModal] = useState(false);
  // 서버 모듈 조회가 끝나야 서버 선택 모달이 뜰지 말지 확정된다 (튜토리얼 시작 스텝 판단에 사용)
  const [isServerModalSettled, setIsServerModalSettled] = useState(false);
  const [isOpenGuide, setIsOpenGuide] = useState(() => !isGuideSeen("main") && !run && !pendingStartRef.current);
  const [isOpenTrainModal, setIsOpenTrainModal] = useState(false);
  const [isFilterOn, setIsFilterOn] = useState<boolean>(false);
  const [myAIModule, setMyAIModule] = useRecoilState(myAIModuleState);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [trainUuid, setTrainUuid] = useRecoilState(trainUuidState);
  const [inspModelUuid, setInspModelUuid] = useRecoilState(inspModelUuidState);
  // 히트맵에 연결할 모델 하나 자동 선택 및 검증 결과 조회
  useHeatmapModel();

  // const [isTraining, setIsTraining] = useRecoilState(isTrainingState);
  const [trainingState, setTrainingState] = useRecoilState(trainingStateAtom);
  // const { setIsTraining } = useTrainingStore();

  const resetImageViewMode = useResetRecoilState(imageViewModeState);
  const resetImageData = useResetRecoilState(imageDataState);
  const resetMyAiModule = useResetRecoilState(myAIModuleState);
  const resetSelectedRow = useResetRecoilState(selectedImageState);
  const [isOpenOption, setIsOpenOption] = useState<boolean>(false);
  // const [layoutMode, setLayoutMode] = useRecoilState(projectLayoutModeState);
  const { layoutMode } = useLayoutStore();

  const overkillPercent = useRecoilValue(overkillPercentState);
  const overkillCount = useRecoilValue(overkillCountState);
  const thresholdCustom = useRecoilValue(overkillCountState);
  const parentModel = useRecoilValue(parentModelState);
  const [selectedServer, setSelectedServer] = useState<string | null>(null);
  const [countdown, setCountdown] = useState<number | null>(null);

  const [isMulti, setIsMulti] = useState(false); //multi-class 여부
  // 설정에서 시작한 튜토리얼이 이 페이지로 이동해 온 경우 이어서 실행.
  useEffect(() => {
    if (!pendingStartRef.current) return;
    const key = tutorialKeyRef.current;
    const modalStepIndex = TUTORIALS[key].findIndex((step) => step.target === "#skip-select-server");
    if (modalStepIndex === -1) {
      pendingStartRef.current = false;
      startTour(key);
      return;
    }

    if (!isServerModalSettled) return;

    pendingStartRef.current = false;
    startTour(key, isOpenServerModal ? modalStepIndex : modalStepIndex + 1);
  }, [isServerModalSettled, isOpenServerModal]);
  const fetchGetAiModule = async () => {
    const formatUuid = label ? `${id}_${label}` : `${id}`;
    setTrainUuid(formatUuid);

    try {
      const [myAiOption, response] = await Promise.all([
        getMyModuleServer(formatUuid, null),
        getLatestTrainHistory(Number(id)),
      ]);

      if (!myAiOption.module || !myAiOption.serverAddress) {
        setMyAIModule(null);
        setIsOpenServerModal(true);
        return;
      }

      const trainStatus = response?.trainHistory?.status;

      setMyAIModule({
        specId: formatUuid,
        serverAddress: myAiOption.serverAddress,
        ...myAiOption.module,
      });
      setIsOpenServerModal(false);
      setOpenSnackbar(false);

      setTrainingState((prev) => ({
        ...prev,
        [Number(id)]: trainStatus === "Training" || trainStatus === "Pending",
      }));
    } catch (err) {
      console.error("fetchGetAiModule error:", err);
      setMyAIModule(null);
    } finally {
      setIsServerModalSettled(true);
    }
  };

  const fetchGetServerList = async () => {
    const response = await getAIServerList();
    setServerList(response);
    console.log("server list:", response);
  };

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
    if (userInfo.config) {
      const userConfig = JSON.parse(userInfo.config);
      setUserConfig(userConfig);
    }

    setIsOpenOption(layoutMode === "default");
  }, []);

  useEffect(() => {
    setIsOpenOption(layoutMode === "default");

    if (layoutMode === "popup") {
      openOptionPopup();
    }
  }, [layoutMode]);

  useEffect(() => {
    resetImageViewMode();
    resetMyAiModule();
    resetSelectedRow();
    fetchGetServerList();
  }, []);

  useEffect(() => {
    fetchGetAiModule();
    resetImageViewMode();
    resetImageData();
  }, [id]);

  // 작업 중이던 AI 서버가 끊겼을 때(요청 실패로 감지) 연결 상태를 정리하고 재연결을 유도
  useEffect(() => {
    const handleAIServerDisconnected = () => {
      setMyAIModule(null);
      setIsOpenServerModal(true);
      toast.error("AI 서버와의 연결이 끊어졌습니다. 서버를 다시 선택해주세요.", {
        toastId: AI_SERVER_DISCONNECTED_EVENT,
      });
    };

    window.addEventListener(AI_SERVER_DISCONNECTED_EVENT, handleAIServerDisconnected);
    return () => window.removeEventListener(AI_SERVER_DISCONNECTED_EVENT, handleAIServerDisconnected);
  }, []);

  useEffect(() => {
    if (projectData?.step === "분석") {
      setIsMulti(true);
    } else {
      setIsMulti(false);
    }
  }, [projectData]);

  const handleServerSelect = async (server: any) => {
    setSelectedServer(server.serverAddress);
    setModelError(null);

    let count = 10;
    setCountdown(count);
    const timer = setInterval(() => {
      count -= 1;
      if (count <= 0) {
        setCountdown(null);
        clearInterval(timer);
      } else {
        setCountdown(count);
      }
    }, 1000);

    try {
      if (projectData && myAIModule?.serverAddress && myAIModule.serverAddress !== server.serverAddress) {
        await removeImportedModules(projectData).catch(console.error);
      }

      if (projectData?.step === "분석") {
        const projectId =
          typeof trainUuid === "string" && trainUuid.includes("_")
            ? trainUuid.split("_")[0]
            : (trainUuid as string) || "";

        const classList = [...projectData.class, "ETC"];

        await Promise.all(
          classList.map(async (item, index) => {
            const uuid = `${projectId}_${item}`;
            await importAIModules(uuid, false, false, true, server.serverAddress, null, inspModelUuid);
          }),
        );

        const response = await getMyModuleServer(trainUuid, null);
        setMyAIModule({
          specId: trainUuid,
          serverAddress: server.serverAddress,
          ...response.module,
        });
        setIsOpenServerModal(false);
      } else {
        await importAIModules(trainUuid, false, false, true, server.serverAddress, null, inspModelUuid);

        const response = await getMyModuleServer(trainUuid, null);
        setMyAIModule({ specId: trainUuid, serverAddress: server.serverAddress, ...response.module });

        setIsOpenServerModal(false);
      }

      if (run) {
        const currentSubStep = TUTORIALS[tutorialKey][stepIndex];
        if (currentSubStep?.nextTrigger === "#insp-img-table" || currentSubStep?.nextTrigger === "#image-list-panel") {
          nextSubStep();
        }
      }
    } catch (error: any) {
      console.error(error);
      const data = error?.response?.data;
      if (data?.code === "INSP_MODEL_NOT_FOUND" || data?.code === "INSP_MODEL_IMPORT_FAILED") {
        setModelError(data.message);
      } else {
        toast.error("선택한 서버에 접속할 수 없습니다. 다른 서버를 선택해주세요.");
      }
    } finally {
      clearInterval(timer);
      setSelectedServer(null);
      setCountdown(null);
    }
  };

  const handleAnnotationMode = async () => {
    const response = await importAIModules(id, false, false, true, "127.0.0.1:50051", null, "annotation_test");
    setMyAIModule({
      specId: trainUuid,
      serverAddress: "127.0.0.1:50051",
      ...response.module,
    });
  };

  // 팝업 오픈 (ai option)
  const openOptionPopup = () => {
    const popup = window.open(
      `${window.location.origin}/#/option-popup?trainUuid=${trainUuid}`,
      "optionPopup",
      "width=480,height=800",
    );

    if (!popup) {
      alert("팝업 차단이 해제되어야 합니다.");
    }
  };

  const handleSaveModel = async (modelInfo: { name: string; desc: string }) => {
    if (projectData === null || myAIModule === null) {
      console.log(projectData, myAIModule);
      toast.error("프로젝트 정보 또는 AI 모듈 정보가 없습니다.");
      return;
    }

    const trainModelData = await getInspModel(projectData?.inspModel_id || 0);

    try {
      const response = await exportAIModules({
        uuid: trainUuid,
        name: modelInfo.name,
        target: `${modelInfo.name}_${new Date().toISOString().slice(0, 19).replace("T", " ")}`,
        infoData: {
          project_id: projectData?.id,
          epoch: 1, //TODO: 추후 변경 필요
          is_complete: false,
          trained_count: 0,
          overkillPercent: overkillPercent,
          overkillCount: overkillCount,
          threshold: myAIModule?.options.labelscore.para.threshold_list[0].toFixed(5) || 0.5,
          parentModel: parentModel || null,
        },
        desc: modelInfo.desc,
        ip: myAIModule?.serverAddress,
        trainModel_id: trainModelData?.data.trainModel.id || 0,
      });
      toast.success("성공적으로 해당 모델을 저장하였습니다.");
      return response;
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <WelcomeGuideModal open={isOpenGuide} onClose={() => setIsOpenGuide(false)} />
      <ServerSelectModal
        open={isOpenServerModal && !isOpenGuide}
        serverList={serverList}
        selectedServer={selectedServer}
        countdown={countdown}
        onSelect={handleServerSelect}
        onAnnotationMode={handleAnnotationMode}
        modelError={modelError}
        onSkip={() => {
          setIsOpenServerModal(false);
          setOpenSnackbar(true);
          // 검사모델 문제면 설정 페이지에서 연결 모델을 바꾸도록 이동
          if (modelError) {
            setModelError(null);
            navigate(`/main/project/${id}/setting`);
          }
        }}
      />

      <Snackbar
        open={openSnackbar && !isOpenServerModal && !isOpenGuide}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        sx={{ bottom: "24px !important" }}
      >
        <Alert
          severity="info"
          icon={false}
          sx={{
            alignItems: "center",
            fontSize: "13px",
            borderRadius: "12px",
            boxShadow: "0 12px 32px rgba(0,0,0,0.22)",
          }}
          action={
            <>
              <Button
                size="small"
                variant="contained"
                onClick={() => {
                  setOpenSnackbar(false);
                  setIsOpenServerModal(true);
                }}
                sx={{ fontSize: "12px", textTransform: "none", borderRadius: "8px", mr: "4px" }}
              >
                서버 연결하기
              </Button>
              <IconButton size="small" onClick={() => setOpenSnackbar(false)}>
                <CloseIcon />
              </IconButton>
            </>
          }
        >
          학습 및 히트맵 확인을 위해 서버 연결이 필요합니다.
        </Alert>
      </Snackbar>

      <LabelingProvider>
        <InspImageProvider serverAddress={myAIModule?.serverAddress} trainUuid={trainUuid!!}>
          <div className="h-full flex flex-col min-h-0">
            <div className="flex flex-1 justify-between min-h-0">
              <div className="flex flex-col h-full w-1/4">
                {projectData?.id === Number(id) && (
                  <ProjectLabelPart step={projectData.step || "분류"} dataSetId={projectData.dataSet_id || -1} />
                )}
              </div>

              <div className={`flex h-full ${isOpenOption ? "flex-1" : "flex-[3]"}`}>
                <ImagePart isFilterOn={isFilterOn} isOpenOption={isOpenOption} isMulti={isMulti} />
              </div>

              {/* ponytail: 분석/분류는 이 컬럼에 띄울 게 없다 → 렌더 자체를 막아 폭을 이미지에 넘김 */}
              {isOpenOption && projectData?.step === "검사" && (
                <div className="flex h-full w-1/4">
                  <AIOptionPart
                    trainUuid={trainUuid || ""}
                    isOpenOption={isOpenOption}
                    handleSaveModel={handleSaveModel}
                    setIsOpenServerModal={setIsOpenServerModal}
                  />
                </div>
              )}
            </div>
          </div>
        </InspImageProvider>
      </LabelingProvider>
    </>
  );
}
